export default __webpack_public_path__ + "static/media/womenCoatTrousers.20f19528.png";